const TRANSPORT = {
  net_zero_futures_dvl_shift_high_0909: {
    2025: { electricity: 14.03, hydrogen: 3.22, fossil: 509.42, biofuels: 3.14,  other: 0.00 },
    2030: { electricity: 29.01, hydrogen: 9.23, fossil: 328.38, biofuels: 6.29,  other: 0.70 },
    2035: { electricity: 55.58, hydrogen: 22.91, fossil: 203.27, biofuels: 23.79, other: 2.56 },
    2040: { electricity: 79.49, hydrogen: 20.64, fossil: 123.17, biofuels: 31.93, other: 5.79 },
    2045: { electricity: 89.05, hydrogen: 15.67, fossil: 81.84,  biofuels: 37.72, other: 16.06 },
    2050: { electricity: 92.45, hydrogen: 12.12, fossil: 40.48,  biofuels: 42.42, other: 41.64 },
  },

  net_zero_futures_dvl_shift_low_0909: {
    2025: { electricity: 14.03, hydrogen: 3.22, fossil: 509.42, biofuels: 3.14,  other: 0.00 },
    2030: { electricity: 29.82, hydrogen: 9.16, fossil: 337.30, biofuels: 5.98,  other: 0.00 },
    2035: { electricity: 59.32, hydrogen: 22.87, fossil: 207.46, biofuels: 25.38, other: 1.19 },
    2040: { electricity: 86.75, hydrogen: 19.98, fossil: 125.26, biofuels: 35.30, other: 3.59 },
    2045: { electricity: 97.77, hydrogen: 14.96, fossil: 92.22,  biofuels: 37.66, other: 10.59 },
    2050: { electricity: 102.74, hydrogen: 10.98, fossil: 56.75, biofuels: 46.14, other: 28.02 },
  },

  net_zero_futures_dvl_steer_high_0909: {
    2025: { electricity: 14.03, hydrogen: 3.22, fossil: 509.42, biofuels: 3.14,  other: 0.00 },
    2030: { electricity: 29.72, hydrogen: 11.43, fossil: 378.71, biofuels: 7.12,  other: 0.85 },
    2035: { electricity: 57.40, hydrogen: 29.54, fossil: 242.26, biofuels: 29.44, other: 2.75 },
    2040: { electricity: 83.01, hydrogen: 27.68, fossil: 153.60, biofuels: 43.78, other: 6.10 },
    2045: { electricity: 96.61, hydrogen: 21.18, fossil: 114.69, biofuels: 42.25, other: 16.85 },
    2050: { electricity: 106.01, hydrogen: 11.85, fossil: 68.59, biofuels: 51.98, other: 43.59 },
  },

  net_zero_futures_dvl_steer_low_0909: {
    2025: { electricity: 14.03, hydrogen: 3.22, fossil: 509.42, biofuels: 3.14,  other: 0.00 },
    2030: { electricity: 30.56, hydrogen: 11.88, fossil: 384.49, biofuels: 7.89,  other: 0.85 },
    2035: { electricity: 61.63, hydrogen: 31.32, fossil: 244.25, biofuels: 29.10, other: 2.75 },
    2040: { electricity: 90.90, hydrogen: 31.59, fossil: 163.99, biofuels: 30.04, other: 6.10 },
    2045: { electricity: 107.37, hydrogen: 23.63, fossil: 131.45, biofuels: 22.25, other: 16.85 },
    2050: { electricity: 119.02, hydrogen: 11.77, fossil: 111.90, biofuels: 8.68,  other: 43.59 },
  },

  net_zero_futures_dvl_transform_high_0909: {
    2025: { electricity: 14.03, hydrogen: 3.22, fossil: 509.42, biofuels: 3.14,  other: 0.00 },
    2030: { electricity: 28.71, hydrogen: 7.46,  fossil: 302.27, biofuels: 5.79,  other: 0.61 },
    2035: { electricity: 55.21, hydrogen: 18.27, fossil: 180.42, biofuels: 22.51, other: 2.44 },
    2040: { electricity: 78.66, hydrogen: 17.45, fossil: 105.99, biofuels: 25.46, other: 5.60 },
    2045: { electricity: 86.68, hydrogen: 12.82, fossil: 69.42,  biofuels: 31.99, other: 15.60 },
    2050: { electricity: 88.01, hydrogen: 10.68, fossil: 29.98,  biofuels: 39.47, other: 40.47 },
  },

  net_zero_futures_dvl_transform_low_0909: {
    2025: { electricity: 14.03, hydrogen: 3.22, fossil: 509.42, biofuels: 3.14,  other: 0.00 },
    2030: { electricity: 29.48, hydrogen: 6.58,  fossil: 310.97, biofuels: 5.79,  other: 0.61 },
    2035: { electricity: 58.65, hydrogen: 16.02, fossil: 189.75, biofuels: 21.55, other: 2.44 },
    2040: { electricity: 86.05, hydrogen: 16.26, fossil: 110.34, biofuels: 26.49, other: 5.60 },
    2045: { electricity: 97.17, hydrogen: 12.72, fossil: 69.04,  biofuels: 33.87, other: 15.60 },
    2050: { electricity: 100.82, hydrogen: 10.73, fossil: 29.98,  biofuels: 37.94, other: 40.47 },
  },

  net_zero_futures_dvl_shift_high_transstshiftec_2001: {
    2025: { electricity: 14.03,    hydrogen: 3.22,    fossil: 509.42, biofuels: 3.14, other: 0 },
    2030: { electricity: 29.01, hydrogen: 9.23,    fossil: 330.95, biofuels: 3.82,  other: 0.61 },
    2035: { electricity: 55.55, hydrogen: 22.59,  fossil: 204.99,  biofuels: 22.80, other: 2.44 },
    2040: { electricity: 79.48, hydrogen: 20.63, fossil: 122.71, biofuels: 32.58, other: 5.60 },
    2045: { electricity: 89.04, hydrogen: 15.66,    fossil: 79.50,  biofuels: 40.53, other: 15.60 },
    2050: { electricity: 92.37, hydrogen: 12.11, fossil: 40.48,     biofuels: 43.59, other: 40.47 },
  },
};


export default TRANSPORT;
